import * as React from "react";

function SvgLine(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M0 0h16v16H0z" fill="none" /><path d="M13.381 9.25H2.708A1.313 1.313 0 011.5 7.95a1.22 1.22 0 011.208-1.2h10.573a1.22 1.22 0 011.208 1.2 1.167 1.167 0 01-1.108 1.3z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgLine);
export default ForwardRef;